import React, { useId } from "react";
import Svg, { ClipPath, Defs, G, LinearGradient, Path, Rect, Stop } from "react-native-svg";

interface DeviceUsage2IllustrationProps {
  width?: number;
  title?: string;
  decorative?: boolean;
}

const VIEWBOX_WIDTH = 86;
const VIEWBOX_HEIGHT = 56;

export function DeviceUsage2Illustration({
  width = 160,
  title,
  decorative = true,
}: DeviceUsage2IllustrationProps) {
  const id = useId();
  const clipPathId = `device-usage-2-clip-${id}`;
  const gradId = `device-usage-2-grad-${id}`;
  const height = (width * VIEWBOX_HEIGHT) / VIEWBOX_WIDTH;

  return (
    <Svg
      title={title}
      viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
      width={width}
      height={height}
      fill="none"
      accessibilityElementsHidden={decorative}
      importantForAccessibility={decorative ? "no-hide-descendants" : "yes"}
      aria-hidden={decorative}
    >
      {/* @ts-expect-error - Defs can have children */}
      <Defs>
        <ClipPath id={clipPathId}>
          <Rect width="86" height="56" fill="#fff" />
        </ClipPath>

        <LinearGradient id={gradId} x1="43" y1="0" x2="43" y2="56" gradientUnits="userSpaceOnUse">
          <Stop stopColor="#6792F0" />
          <Stop offset="1" stopColor="#164081" />
        </LinearGradient>
      </Defs>

      <G clipPath={`url(#${clipPathId})`}>
        {/* Backdrop shape */}
        <Path d="M2 40h82L70 18H8L2 40Z" fill="#B6C8F2" />

        {/* Sparkles */}
        <Path d="M8 8l1.5 3L13 12l-3.5 1L8 16l-1.5-3L3 12l3.5-1L8 8Z" fill="#004FCB" />
        <Path d="M26 30l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2Z" fill="#6792F0" />

        {/* Phone shell */}
        <Rect x="21" y="2" width="36" height="48" rx="8" fill={`url(#${gradId})`} />
        <Rect x="25" y="6" width="28" height="40" rx="4" fill="#fff" />

        {/* Notch / speaker */}
        <Rect x="33" y="4" width="12" height="2.5" rx="1.25" fill="#1D465C" />
        <Rect x="39" y="4.7" width="2" height="1" rx="0.5" fill="#6792F0" />

        {/* Inner card */}
        <Rect x="31" y="14" width="16" height="22" rx="1.5" fill="#F5F7FF" />
        <Path d="M39 18c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7Z" fill="#1F5F7B" />
        <Path
          d="M39 21l1.3 2.6 2.9.4-2.1 2.1.5 2.9-2.6-1.4-2.6 1.4.5-2.9-2.1-2.1 2.9-.4L39 21Z"
          fill="#D9F4EE"
        />

        {/* Bottom CTA */}
        <Rect x="30" y="37" width="18" height="6" rx="1.5" fill="#004FCB" />
        <Path
          d="M39 38.2a1.8 1.8 0 0 1 1.8 1.8v1a1.8 1.8 0 1 1-3.6 0v-1a1.8 1.8 0 0 1 1.8-1.8Z"
          fill="#fff"
        />
        <Path d="M39 42.4v1.3M37.7 42.9h2.6" stroke="#fff" strokeWidth="1" strokeLinecap="round" />
      </G>
    </Svg>
  );
}
